import { render, staticRenderFns } from "./twitter-view.vue?vue&type=template&id=5284bb0a&scoped=true&"
import script from "./twitter-view.vue?vue&type=script&lang=js&"
export * from "./twitter-view.vue?vue&type=script&lang=js&"
import style0 from "./twitter-view.vue?vue&type=style&index=0&id=5284bb0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5284bb0a",
  null
  
)

export default component.exports